import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core'
import { CurrencyService } from '@spartacus/core'
import { SnackbarService } from '../../../../../shared/directive/snackBar/snackbar.service'
import { Discounts } from '../../../../../models/discounts.model'

@Component({
  standalone: false,
  selector: 'vs-quote-tracking-product',
  templateUrl: './quote-tracking-product.component.html',
  styleUrls: ['./quote-tracking-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteTrackingProductComponent implements OnInit {
  @Input() product: any
  @Input() productOpen
  @Input() index
  breakUp = false
  currency: string

  constructor(
    public snackbar: SnackbarService,
    private elementRef: ElementRef,
    private currencyService: CurrencyService
  ) {}
  ngOnInit(): void {
    this.currencyService.getActive().subscribe((currency) => {
      this.currency = currency
    })
  }
  toggleProduct() {
    this.productOpen = !this.productOpen
  }
  openViewBreakup() {
    this.breakUp = true
  }
  closeMenu(event) {
    this.breakUp = false
  }

  // @HostListener('document:click', ['$event.target'])
  // public onClick(target) {
  //   const clickedInside = this.elementRef.nativeElement.querySelector('.price-menu').contains(target);
  //   if (!clickedInside && !this.elementRef.nativeElement.querySelector('.view-price-details').contains(target)) {
  //     this.breakUp = false;
  //   }
  // }
  getDiscountName(code) {
    return Discounts[code]
  }
  getTotalDiscounts(discounts?, adders?) {
    let totalDisc = 0
    let totalAdds = 0
    let discVal = discounts[0]?.formattedValue.trim()
    let addrVal = adders[0]?.formattedValue.trim()
    for (const disc of discounts) {
      totalDisc += disc.value
    }
    for (const adds of adders) {
      totalAdds += adds.value
    }
    if (this.currency == 'JPY') {
      return (
        (discVal[0] || addrVal[0]) +
        ((totalAdds || 0) - (totalDisc || 0)).toFixed(0)
      )
    } else {
      return (
        (discVal[0] || addrVal[0]) +
        ((totalAdds || 0) - (totalDisc || 0)).toFixed(2)
      )
    }
  }
}
